
// get options
let translations = [];
export async function getTranslations(apiLink) {
    let url = `${window.location.protocol}//${window.location.hostname}`;
    if ( window.location.hostname == 'localhost' ) {
        url = 'https://bkfcarwash.info';
    }
    await fetch(`https://${apiLink}/wp-json/wp/v2/realizations-map/translations`)
        .then(resp => resp.json())
        .then(resp => {
            translations = resp;
        })
    return 1;
}  

export function getTranslateLang(stringName) {
    let word = ``;
    if ( translations.length > 0) {
        // button translate
        let buttonTranslate = translations.map(item => item.name === stringName ? item.title : null);
        buttonTranslate = buttonTranslate.filter((el) => (el));

        // return translate
        word = `I can't find this translate`;
        if ( buttonTranslate.length > 0 ) {
            word = buttonTranslate[0];
        }
    }
    
    return word;
} 